"use client";

import ProtectedVideo from "@/components/ui/ProtectedVideo";
import { openModal } from "@/redux/slices/allModalSlice";
import { useDispatch } from "react-redux";

interface VideoWithPlayButtonProps {
  src: string;
  title?: string;
  className?: string;
  poster?: string;
}

export default function VideoWithPlayButton({ src, title, className = "", poster }: VideoWithPlayButtonProps) {
  const dispatch = useDispatch();

  const handlePlayClick = () => {
    dispatch(openModal({
      componentName: "VideoModal",
      modalSize: "4xl",
      data: { videoUrl: src },
    }));
  };

  return (
    <div className={`relative w-auto h-auto group ${className}`}>
      <ProtectedVideo
        src={src}
        poster={poster}
        playsInline
        className="block w-full h-auto max-w-full max-h-[350px] lg:max-h-[500px] aspect-square object-cover"
        title={title}
        muted
        preload={poster ? "none" : "metadata"}
      />
      <button
        type="button"
        onClick={handlePlayClick}
        className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors hover:bg-black/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 rounded-3xl cursor-pointer"
        aria-label="Play video"
      >
        <span className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-white/90 hover:bg-white shadow-lg transition-transform group-hover:scale-105">
          <svg
            className="w-8 h-8 md:w-10 md:h-10 text-gray-900 ml-1"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden
          >
            <path d="M8 5v14l11-7L8 5z" />
          </svg>
        </span>
      </button>
    </div>
  );
}
